import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'eca-app-alert',
  templateUrl: './alert-box.component.html',
  styleUrls: ['./alert-box.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MatIcon]
})
export class AlertBoxComponent {

  @Input() type: string;
  @Input() icon: string;
  @Input() text: string;

  constructor() {
  }

}

type AlertType = 'success' | 'error' | 'info';

export class Alert {

  constructor(public type: AlertType,
              public icon: string,
              public text: string) {
  }
}
